module.exports = __webpack_public_path__ + "static/media/upgrade-vps.192ed417.png";